export default __webpack_public_path__ + "static/media/dropkickmurphys.90cc1b6c.jpeg";